import { ProjectSubmitApi } from 'api/ProjectSubmitApi';
import { backendApiClient } from 'container/backendApiClient';

export const projectSubmitApi = new ProjectSubmitApi(backendApiClient);
